import FormEditor from 'routes/ReferralForm/FormEditor/FormEditor';

export default FormEditor;
